import Box from '@mui/material/Box';
import { React, useEffect, useState } from 'react';
import ModalContainer from '../ModalContainer';
import ModalTitle from '../Text/ModalTitle';
import OutlineButton from '../Buttons/outline/OutlinedModalButton';
import Colors from '../../../colors';
import TextInput from '../../TextInput';
import { toTitleCase } from '../../../utils/helpers';

function SingleTextInputModal({ modalLabel, inputLabel, defaultValue, isVisible, setIsVisible, dataCallback }) {
    const [textData, setTextData] = useState(defaultValue);
    const [error, setError] = useState(false);

    useEffect(() => {
        setTextData(defaultValue);
    }, [defaultValue]);

    const saveButtonOnClickHandler = () => {
        if (textData.trim().length === 0) {
            setError(true);
            setTimeout(() => {
                setError(false);
            }, 2000)
        } else {
            dataCallback(toTitleCase(textData));
            setIsVisible(false);
        }
    };

    return (
        <ModalContainer isVisible={isVisible} setIsVisible={setIsVisible} >
            <Box sx={{
                width: '100%',
                p: 2.5
            }}>
                <ModalTitle label={modalLabel} />
                <TextInput
                    error={error}
                    label={inputLabel}
                    value={defaultValue}
                    setText={setTextData} />
                <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "30px",
                }}>
                    <OutlineButton
                        onClick={saveButtonOnClickHandler}
                        color={Colors.green}
                        label={'Save'} />
                </Box>
            </Box>
        </ModalContainer>
    );
}

export default SingleTextInputModal;